var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    clipPath: "url(#clip0_21523_54428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.12109 0.75C3.22188 0.75 0.871094 3.10078 0.871094 6C0.871094 8.89922 3.22188 11.25 6.12109 11.25C9.02031 11.25 11.3711 8.89922 11.3711 6C11.3711 3.10078 9.02031 0.75 6.12109 0.75ZM6.49609 8.53125C6.49609 8.58281 6.45391 8.625 6.40234 8.625H5.83984C5.78828 8.625 5.74609 8.58281 5.74609 8.53125V5.34375C5.74609 5.29219 5.78828 5.25 5.83984 5.25H6.40234C6.45391 5.25 6.49609 5.29219 6.49609 5.34375V8.53125ZM6.12109 4.5C5.9739 4.497 5.83374 4.43641 5.73071 4.33125C5.62767 4.22609 5.56996 4.08473 5.56996 3.9375C5.56996 3.79027 5.62767 3.64891 5.73071 3.54375C5.83374 3.43859 5.9739 3.378 6.12109 3.375C6.26829 3.378 6.40844 3.43859 6.51148 3.54375C6.61452 3.64891 6.67223 3.79027 6.67223 3.9375C6.67223 4.08473 6.61452 4.22609 6.51148 4.33125C6.40844 4.43641 6.26829 4.497 6.12109 4.5Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21523_54428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.121094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a7a56f5389a1b408cb86a6b788be9a87.svg";
export { ForwardRef as ReactComponent };